export enum Plans {
  draft = 0,
  published = 1
}
